export const SERVER_API_URL = "/api";
export const SERVER_TIMEOUT = 1 * 60 * 1000;

export const SESSION_PREFIX = "wg_";
export const TOKEN_LOCAL_KEY = `${SESSION_PREFIX}tokens`;